export enum ProcessingResult {
  Success = 'Success',
  Failure = 'Failure',
}
